<ng-container *ngIf="campaignItem.typeID == 21 || campaignItem.typeID == 20" >
	<span *ngFor="let icon of campaignItemIcon;" class="itemImageWrapper">
		<img src="{{ icon }}" />
	</span>
</ng-container>
